module.exports = __webpack_public_path__ + "img/pie.375daaec.svg";